/**
 * @generated SignedSource<<ca00c9e65e58995e42aec92467779c86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardDiagnosticQuery$variables = {
  skip: boolean;
  studentId: string;
};
export type DashboardDiagnosticQuery$data = {
  readonly currentTargetGroupByStudentId?: {
    readonly id: string;
    readonly isActive: boolean;
    readonly isCurrent: boolean;
    readonly targetGroup: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly targets: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
        readonly summary: string | null | undefined;
        readonly targetGroup: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly user: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
  readonly latestCompletedStudentSkillDiagnostic?: {
    readonly id: string;
    readonly isComplete: boolean;
    readonly isInferred: boolean;
    readonly retakeAssigned: boolean;
  } | null | undefined;
};
export type DashboardDiagnosticQuery = {
  response: DashboardDiagnosticQuery$data;
  variables: DashboardDiagnosticQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studentId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "studentId",
    "variableName": "studentId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v3/*: any*/)
],
v6 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StudentTargetGroupNode",
        "kind": "LinkedField",
        "name": "currentTargetGroupByStudentId",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCurrent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetGroupNode",
            "kind": "LinkedField",
            "name": "targetGroup",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "isActive": "ACTIVE"
                    }
                  }
                ],
                "concreteType": "TargetNode",
                "kind": "LinkedField",
                "name": "targets",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "summary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TargetGroupNode",
                    "kind": "LinkedField",
                    "name": "targetGroup",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": "targets(filter:{\"isActive\":\"ACTIVE\"})"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StudentSkillDiagnosticNode",
        "kind": "LinkedField",
        "name": "latestCompletedStudentSkillDiagnostic",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isComplete",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "retakeAssigned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isInferred",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardDiagnosticQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DashboardDiagnosticQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "9c1f44d2b1a3a1e21f7218374c5c1b69",
    "id": null,
    "metadata": {},
    "name": "DashboardDiagnosticQuery",
    "operationKind": "query",
    "text": "query DashboardDiagnosticQuery(\n  $studentId: ID!\n  $skip: Boolean!\n) {\n  currentTargetGroupByStudentId(studentId: $studentId) @skip(if: $skip) {\n    id\n    isCurrent\n    isActive\n    targetGroup {\n      id\n      name\n      targets(filter: {isActive: ACTIVE}) {\n        id\n        name\n        summary\n        targetGroup {\n          id\n        }\n      }\n    }\n    user {\n      id\n    }\n  }\n  latestCompletedStudentSkillDiagnostic(studentId: $studentId) @skip(if: $skip) {\n    id\n    isComplete\n    retakeAssigned\n    isInferred\n  }\n}\n"
  }
};
})();

(node as any).hash = "7da53acc1aff8e3dbefcf2c5f4280cf5";

export default node;
